import { css } from '@styled-system/css';
import { App, message as messageStatic } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/** Clé unique : un second clic remplace la notification au lieu d'en empiler une autre. */
const NOTICE_KEY = 'vestiaire-locked';
/** Durée d'affichage (s) : le temps de lire la phrase et d'atteindre le lien. */
const NOTICE_DURATION_S = 6;

const ctaLink = css({
  ml: '2',
  p: '0',
  bg: 'transparent',
  border: 'none',
  color: 'text.brand',
  fontWeight: 'medium',
  textDecoration: 'underline',
  cursor: 'pointer',
});

/**
 * Clic sur une commande Vestiaire verrouillée par le plan (2026-10-01) : notification
 * d'information (`vestiaireSearch.lockedHint` + lien « Voir les abonnements » vers `/subscription`).
 * Le clic lui-même ne navigue PAS : sur tactile l'infobulle ne s'ouvre jamais, une navigation
 * directe perdrait sans explication la saisie en cours (ex. formulaire de `SearchModal`).
 */
export const useVestiaireLockedNotice = (): (() => void) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // AntD App pour les toasts ; repli sur l'API statique hors <App> (même motif que `SearchModal`)
  let appMessage: typeof messageStatic;
  try {
    appMessage = App.useApp().message as unknown as typeof messageStatic;
  } catch {
    appMessage = messageStatic;
  }

  return useCallback(() => {
    void appMessage.info({
      key: NOTICE_KEY,
      duration: NOTICE_DURATION_S,
      content: (
        <span>
          {t('vestiaireSearch.lockedHint')}
          <button
            type="button"
            className={ctaLink}
            onClick={() => {
              appMessage.destroy(NOTICE_KEY);
              navigate('/subscription');
            }}
          >
            {t('trend.trialLockedCta')}
          </button>
        </span>
      ),
    });
  }, [appMessage, navigate, t]);
};
